<order-tag>
<div class="contents contents-wide">
  <section class="contents_area">
    <div class="container_heading">
      <h1 class="heading-01 heading_orders">注文一覧</h1>
      <ul class="breadcrumb">
        <li class="breadcrumb-item"><a href="/menu" class="home">ホーム</a></li>
        <li class="breadcrumb-item">注文一覧</li>
      </ul>
    </div><!--/.container_heading-->
    
    <div class="lead_block">
      <p>過去にご注文いただいた注文情情報の一覧です。</p>
      <p class="notice">※注文情報の詳細はサービスの管理画面にリンクしておりますので、アクセス権限がないと参照できません。</p>
    </div><!--/.lead_block-->
    
    <div class="table-nav_area">
      <div class="search-conditions_area">
        <p class="search-conditions-heading">現在の検索条件：</p>
        <ul class="search-conditions-list">
          <li class="search-conditions-list-item" each={item in searchConditions()}>
            <span class="label label-search-conditions" onclick={(e)=>deleteCond(e, item.key)}>
              {item.name}: {item.value}
            </span>
          </li>
        </ul>
      </div><!--/.search-conditions_area-->
      <button class="button button-modal button-modal-search" type="button" value="検索条件設定" onclick={(e)=>{MenuApi.event('order','openSearchModal')}}>検索条件設定</button>
    </div><!--/.table-nav_area-->
    
    <div class="table-nav_area">
      <p class="search_number">全{state.datainfo.total}件中　{state.datainfo.start}〜{state.datainfo.end}件</p>
      <div class="sort-menu">
        <label for="sort" class="sort-menu-title">表示件数</label>
        <select name="limit" id="limit" class="sort-list" onchange={(e)=>setlimit(e)}>
          <option value="10">10件</option>
          <option value="20">20件</option>
          <option value="50">50件</option>
          <option value="100">100件</option>
        </select>
      </div><!--/.sort-menu-->
    </div><!--/.table-nav_area-->
    
    <order-list-tag
      MenuApi={MenuApi}
      params={state.params}
      updatePage={updatePage}
      setOrderBy={setOrderBy}
      pagerBinder={pagerBinder}
    ></order-list-tag>

    <order-search-modal
      modalId="order-search-modal"
      MenuApi={MenuApi}
      search={search}
    ></order-search-modal>
   
  </section><!--/.contents_area-->
</div><!--/.contents-->

<script>
  import di from "dependeny-injection";
  import orderListTag from "@tags/parts/order-list.riot";
  import orderSearchModal from "@tags/modal/menu/order-search-modal.riot";
  import Status from "@model/status.js";
  export default {
    MenuApi: false,
    state: {
      params: {},
      datainfo: {total: 0, start: 0, end:0}
    },
    components: {
      "order-list-tag": orderListTag,
      "order-search-modal": orderSearchModal
    },
    pagerBinder(pager){
      const start = 1 + ((pager.page -1) * (this.state.params.limit || 10));
      this.update({datainfo:{
        total: pager.total,
        start: start,
        end: start + pager.items.length - 1
      }});
    },
    searchConditions(){
      const items = [];
      const conditions = {
        status: 'ステータス',
        //staff: '担当者',
        order_id: '注文ID',
        service: 'サービス',
        range_start: 'お申込日(開始)',
        range_end: 'お申込日(終了)',
      };
      Object.keys(this.state.params)
      .filter(k => Object.keys(conditions).indexOf(k) != -1)
      .filter(k => this.state.params[k])
      .forEach( (k) => {
        let val = this.state.params[k];
        if (k === 'status') val = Status.order(this.state.params[k]).text;
        items.push({
          key: k,
          name: conditions[k],
          value: val
        });
      });
      return items;
       
    },
    setlimit(e){
      let lim = $("select[name=limit]").val();
      this.state.params.limit = lim;
      this.state.params.page = 1;
      this.update();
      this.MenuApi.event('order', 'search');
    },
    setOrderBy(direction){
      this.state.params.orderby = direction;
      this.state.params.page = 1;
      this.update();
      this.MenuApi.event('order', 'search');
    },
    updatePage(pageNo) {
      this.state.params.page = pageNo;
      this.update();
      this.MenuApi.event('order', 'search');
    },
    deleteCond(e, k) {
      delete this.state.params[k];
      this.update();
      this.MenuApi.event('order', 'search');
    },
    search(params) {
      params.limit = this.state.params.limit;
      this.update({params: params});
      this.MenuApi.event('order', 'search');
    },
    onBeforeMount(){
      this.MenuApi = di.createApi();
    }
  }
</script>
</order-tag>
